import { useAuthContextV2 } from "../../../../../auth-state";
import { SettingR } from "../../route";
import { Redirect } from "react-router-dom";
import { SettingsTemplate } from "../../../../template/settings/default-template";
import { StaticFeatureFlags } from "../../../../../feature-flags";
import { lazy, Suspense } from "react";
import { Spinner } from "@graffer-inc/console-design-kit";

const SmartApplyRedoc = lazy(() => import("./smart-apply-redoc"));

export const SmartApplyApiSpecPage = () => {
  const { auth } = useAuthContextV2();

  if (
    !(
      auth.hasPermissions("service_account.service_account.read") &&
      auth.isProductAvailable("SmartApply") &&
      StaticFeatureFlags.ENABLE_SMART_APPLY_EXTERNAL_API_SPEC
    )
  ) {
    return <Redirect to={SettingR.MyAccount.link({})} />;
  }

  return (
    <SettingsTemplate
      breadcrumbs={[{ to: "#", title: "スマート申請API仕様書" }]}
    >
      <Suspense fallback={<Spinner loading={true} />}>
        <SmartApplyRedoc />
      </Suspense>
    </SettingsTemplate>
  );
};
